import OffCanvasNav from './../navbar_off_canvas/Navbar_Off_Canvas';

export default new class {

  constructor() {
    const defaults= {
      btnOffCanvas: '.btn-offcanvas',
      callBtn: '.btn-call',
    };

    let elem = document.querySelector('#global-header');

    if (!elem){
      return;
    }

    /*
    Define nodes / elements
     */
    this.$elem = elem;
    this.$btnOffCanvas = elem.querySelector(defaults.btnOffCanvas);
    this.$callBtn = document.querySelector(defaults.callBtn);

    /*
    Event binding
     */
    this.bindEvents();
  }

  bindEvents(){
    this.$btnOffCanvas.addEventListener('click', () => {
      OffCanvasNav.toggleNav();
    });
    this.$callBtn.addEventListener('click', () => {
      window.ArnAnalytics.customEvent({
        category: 'Button Interaction',
        action: 'Call Button Press',
      });
    });
  }
}
